import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function ProtectedRoute({ children, ownerOnly = false, allowForcedChange = false }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === undefined) {
    return (
      <div className="max-w-3xl mx-auto px-5 py-20">
        <div className="h-10 w-2/3 scanning" />
      </div>
    );
  }
  if (user === null) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  // If the user is on a temp password, force them to the change-password
  // screen until they pick a new one. `allowForcedChange` lets that screen
  // itself be reachable.
  if (user.must_change_password && !allowForcedChange) {
    return <Navigate to="/change-password" replace state={{ from: location.pathname }} />;
  }
  if (ownerOnly && user.role !== "owner") {
    return (
      <div className="max-w-xl mx-auto px-5 py-20 text-center">
        <h1 className="font-serif text-4xl text-[#1E2520] mb-3">Sezione riservata</h1>
        <p className="text-[#5C635A]">Questa pagina è accessibile solo al proprietario.</p>
      </div>
    );
  }
  return children;
}
